/**
 * Created by koqiui on 2017-04-12.
 */
import api from './index';

let exports = {};

exports.getInvoiceVoucher = function (params, callback) {
    api.get('/invoice/voucher/get')
        .params(params)
        .done(callback)
        .fail(callback)
        .go();
};

exports.getInvoiceVoucherPageList = function (data, callback) {
    api.post('/invoice/voucher/page/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

exports.createInvoiveVoucher = function (data, callback) {
    api.post('/invoice/voucher/create/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 开具发票
exports.issueInvoiceVoucher = function (data, callback) {
    api.post('/invoice/voucher/issue/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 发票收回
exports.retrieveInvoiceVoucher = function (data, callback) {
    api.post('/invoice/voucher/retrieve/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 发票作废
exports.invalidInvoiceVoucher = function (data, callback) {
    api.post('/invoice/voucher/invalid/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 发票删除
exports.deleteInvoiceVoucher = function (data, callback) {
    api.post('/invoice/voucher/delete/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/invoiceVoucher.js
// module id = 141
// module chunks = 1